<template>
  <div class="listform">
    <div class="form-title">家装公司单量统计
      <Icon type="briefcase"></Icon>
    </div>
    <div class="search_option">
      <DatePicker type="daterange" @on-change="DateTimeSelect" :options="dateSearchOption" placement="bottom-end"
        placeholder="根据上传时间筛选" style="width: 200px"></DatePicker>
      <Button type="primary" @click="Search" icon="ios-search">搜索</Button>
      <Button @click="ExportExcel()" type="primary" icon="ios-clipboard">导出</Button>
    </div>

    <div class="datatable">
      <Table :border="false"  size="small" @on-sort-change="Sort" :columns="table.tablecolumsTitle"
        :loading="table.loading" :data="table.datalist"></Table>
    </div>
    <div class="footerpage">
      <Page :total="table.total" :page-size="table.pageSize" @on-change="PageChange" :current="table.pageIndex"
        show-elevator></Page>
    </div>
  </div>
</template>
<script>
import workerRolSel from "../../components/public_component/workerRowSel";
export default {
  data() {
    return {
      dateSearchValue: "",
      dateSearchOption: {
        shortcuts: [
          {
            text: "一周内",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: "一月内",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: "一年内",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              return [start, end];
            }
          }
        ]
      },
      sel_field: "",
      table: {
        tablecolumsTitle: [
          {
            title: "经销商",
            key: "DealerName",
            align: "center",
            tooltip: true
          },
          {
            title: "装饰公司",
            key: "Name",
            align: "center",
            tooltip: true
          },
          {
            title: "维护人（渠道）",
            key: "EmployeeName",
            align: "center",
            tooltip: true
          },
          {
            title: "维护人（家装）",
            key: "Employee5Name",
            align: "center",
            tooltip: true
          },
          {
            title: "试压地址",
            key: "CustAddress",
            align: "center",
            tooltip: true
          },
          {
            title: "管道类型",
            key: "PipeTypeDesc",
            align: "center",
            tooltip: true           
          },
          {
            title: "经销商录单家装公司是否与现场一致",
            key: "IsCompanySame",
            align: "center",
            tooltip: true,
            render: (h, params) => {
              const row = params.row;
              const color = (row.IsCompanySame == 1 && "success") || "error";
              const text = (row.IsCompanySame == 1 && "是") || "否";
              return h(
                "Tag",
                {
                  props: {
                    type: "dot",
                    color: color
                  }
                },
                text
              );
            }
          },
          {
            title: "现场是否有家装公司标识",
            key: "IsCompanyLogo",
            align: "center",
            tooltip: true,
            render: (h, params) => {
              const row = params.row;
              const color = (row.IsCompanyLogo == 1 && "success") || "error";
              const text = (row.IsCompanyLogo == 1 && "是") || "否";
              return h(
                "Tag",
                {
                  props: {
                    type: "dot",
                    color: color
                  }
                },
                text
              );
            }
          },
          {
            title: "核实人/核实原因",
            key: "Checker",
            align: "center",
            color: "red",
            tooltip: true
          },
          {
            title: "家装公司标识与录单家装公司是否一致",
            key: "IsLogoSame",
            align: "center",
            tooltip: true,
            render: (h, params) => {
              const row = params.row;
              const color = (row.IsLogoSame == 1 && "success") || "error";
              const text = (row.IsLogoSame == 1 && "是") || "否";
              return h(
                "Tag",
                {
                  props: {
                    type: "dot",
                    color: color
                  }
                },
                text
              );
            }
          },
          {
            title: "物流码与录单经销商是否一致",
            key: "IsCodeSame",
            align: "center",
            tooltip: true,
            render: (h, params) => {
              const row = params.row;
              const color = (row.IsCodeSame == 1 && "success") || "error";
              const text = (row.IsCodeSame == 1 && "是") || "否";
              return h(
                "Tag",
                {
                  props: {
                    type: "dot",
                    color: color
                  }
                },
                text
              );
            }
          },
          {
            title: "试压时间",
            key: "CreateTime",
            align: "center",
            color: "red",
            tooltip: true
          }
        ],
        datalist: [],
        pageIndex: 1,
        total: 0,
        pageSize: 1,
        loading: true,
        sort: " "
      }
    };
  },
  components: {
    "worker-RowSel": workerRolSel
  },
  methods: {
    //行选中事件
    WorkerRowSel: function(e) {
      if (this.IsEditWorker) {
        this.EditWorker(undefined, e);
        return;
      }
      this.PreSelWorker(undefined, e);
    },
    ModalCancel: function(e) {
      console.log("取消");
      this.$http.SetConditions();
    },
    DateTimeSelect: function(e) {
      this.dateSearchValue = e;
    },
    PageChange: function(e) {
      this.table.pageIndex = e;
      this.GetTableList();
      this.$router.push({
        name: "companystatistics",
        query: { pageindex: e }
      });
    },
    GetTableList: function() {
      var that = this;
      that.table.loading = true;
      this.$http
        .get("Company/GetCompany6PageList", {
          params: { pageIndex: that.table.pageIndex, sort: that.table.sort }
        })
        .then(res => {
          that.table.loading = false;
          that.table.datalist = res.data.ListData;
          that.table.total = res.data.TotalCount;
          that.table.pageSize = res.data.PageSize;
        });
    },
    Search: function(e) {
      this.loading = true;
      var conditions = [];

      if (this.dateSearchValue != "") {
        if (this.dateSearchValue[0] != "" && this.dateSearchValue[1] != "") {
          if (this.dateSearchValue[0] == this.dateSearchValue[1]) {
            conditions.push({
              PropertyName: "CreateTime",
              Operater: 2,
              LogicOperater: 0,
              Value: this.dateSearchValue[0]
            });
          } else {
            conditions.push(
              {
                PropertyName: "CreateTime",
                Operater: 3,
                LogicOperater: 0,
                Value: this.dateSearchValue[0]
              },
              {
                PropertyName: "CreateTime",
                Operater: 4,
                LogicOperater: 0,
                Value: this.dateSearchValue[1]
              }
            );
          }
        }
      }
      this.$http.SetConditions(conditions);
      this.GetTableList();
    },
    ExportExcel:function () {//导出
      var that=this;
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", "生成中..")
          ]);
        }
      });
      that.$http.get("Company/ExportCompanyDetail",{
        params:{}
      }).then(res=>{
        that.$Spin.hide();
        window.open(that.$config.fileUrl + res.data);
      })
    },
  },
  created: function() {
    this.GetTableList();
  }
};
</script>
<style>
.radio-group {
  margin: 10px;
  padding-left: 10px;
}
.datatable {
  margin-top: 5px;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked {
  background: #2d8cf0;
  color: #f8f8f8;
}
</style>
 